import { render } from "./FrontofficeProfil.vue?vue&type=template&id=461c071c&scoped=true&ts=true"
import script from "./FrontofficeProfil.vue?vue&type=script&lang=ts"
export * from "./FrontofficeProfil.vue?vue&type=script&lang=ts"

import "./FrontofficeProfil.vue?vue&type=style&index=0&id=461c071c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461c071c"]])

export default __exports__